import { FileDetails } from 'sos-common/js/commonTypes/fileupload.types';
import { FileExtendedDetails, FileState } from 'sos-common/js/commonTypes/fileupload.types';
import { doDelete, doPost } from './fetch.service';
import { ResponseError } from 'sos-common/js/utils/ResponseError';

export function postFilesRedux(file: FileExtendedDetails, orderId: string, fieldName: string) {
  const form = new FormData();
  form.append('orderId', orderId);
  form.append(file.OriginalFilename, file.file);
  const path = `/${fieldName}/attach`;
  return doPost<FileExtendedDetails>(path, form).then((responseFile) => {
    if (!(responseFile instanceof ResponseError)) {
      responseFile.status = FileState.SETTLED;
    }
    return responseFile;
  });
}

export function deleteFileRedux(file: FileExtendedDetails, orderId: string, fieldName: string) {
  const form = new FormData();
  form.append('fileId', file.FileId);
  form.append('orderId', orderId);
  const path = `/${fieldName}/delete`;

  return doDelete<FileDetails[]>(path, form);
}
